import isEmpty from 'is-empty';
import {
  REDEEM_MUTUAL_FUND_INVESTMENT,
  REDEEM_MUTUAL_FUND_INVESTMENT_ERROR,
  REDEEM_MUTUAL_FUND_INVESTMENT_LOADING,
  REDEEM_MUTUAL_FUND_INVESTMENT_ERROR_DELETE
} from '../../actions/types';

const initialState = {
  success: false,
  redeemMutualFund: {},
  error: '',
  loading: false
};

const redeemMutualFund = (state = initialState, action) => {
  switch (action.type) {
    case REDEEM_MUTUAL_FUND_INVESTMENT:
      return {
        ...state,
        success: !isEmpty(action.mutualFund),
        withdrawFixLip: action.mutualFund,
        loading: false
      };
    case REDEEM_MUTUAL_FUND_INVESTMENT_ERROR:
      return {
        ...state,
        success: false,
        error: action.error,
        loading: false
      };
    case REDEEM_MUTUAL_FUND_INVESTMENT_ERROR_DELETE:
      return {
        error: ''
      };
    case REDEEM_MUTUAL_FUND_INVESTMENT_LOADING:
      return {
        ...state,
        loading: true
      };
    default:
      return state;
  }
};

export default redeemMutualFund;
